// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import flexibility from 'flexibility'
import 'babel-polyfill'
import './components/common/urlPolyfill'
import Promise from 'promise-polyfill'
import setAsap from 'setasap'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import plTable from 'pl-table'
import 'pl-table/themes/index.css'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import zh from './components/common/lang/zh/gateway'
import locale from 'element-ui/lib/locale';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import authToken from './components/common/authToken'
import App from './App'
import router from './router'
import md5 from 'js-md5'
import mqtt from 'mqtt'
// import confi from '../static/config.json'
import confi from './components/common/configuration'
import webSocket from './components/common/webSocket'
import {permiConst} from './components/common/constVars'

// console.log(confi)
Vue.config.productionTip = false

Promise._immediateFn = setAsap;
Vue.use(ElementUI, VueAxios, axios);
Vue.use(VueI18n)
Vue.use(plTable)

ElementUI.Input.render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
  _vm.inputSize ? 'el-input--' + _vm.inputSize : '',
  {
    'is-disabled': _vm.inputDisabled,
    'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
    'el-input-group--append': _vm.$slots.append,
    'el-input-group--prepend': _vm.$slots.prepend,
    'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
    'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon || _vm.clearable
  }
  ],on:{"mouseover":function($event){_vm.hovering = true},"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false}}},[(_vm.type !== 'textarea')?[(_vm.$slots.prepend)?_c('div',{staticClass:"el-input-group__prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"el-input__inner",attrs:{"tabindex":_vm.tabindex,"type":_vm.type,"disabled":_vm.inputDisabled,"readonly":_vm.readonly,"autocomplete":_vm.autoComplete,"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'input',_vm.$attrs,false)):_vm._e(),(_vm.$slots.prefix || _vm.prefixIcon)?_c('span',{staticClass:"el-input__prefix"},[_vm._t("prefix"),(_vm.prefixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.prefixIcon}):_vm._e()],2):_vm._e(),(_vm.$slots.suffix || _vm.suffixIcon || _vm.showClear || _vm.validateState && _vm.needStatusIcon)?_c('span',{staticClass:"el-input__suffix"},[_c('span',{staticClass:"el-input__suffix-inner"},[(!_vm.showClear)?[_vm._t("suffix"),(_vm.suffixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.suffixIcon}):_vm._e()]:_c('i',{staticClass:"el-input__icon el-icon-circle-close el-input__clear",on:{"click":_vm.clear}})],2),(_vm.validateState)?_c('i',{staticClass:"el-input__icon",class:['el-input__validateIcon', _vm.validateIcon]}):_vm._e()]):_vm._e(),(_vm.$slots.append)?_c('div',{staticClass:"el-input-group__append"},[_vm._t("append")],2):_vm._e()]:_c('textarea',_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:(_vm.textareaStyle),attrs:{"tabindex":_vm.tabindex,"disabled":_vm.inputDisabled,"readonly":_vm.readonly,"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'textarea',_vm.$attrs,false))],2)}
// console.log(ElementUI.Input.render)

// axios.defaults.baseURL = 'http://192.168.0.229:9191'
axios.defaults.baseURL = confi.serverIp
axios.defaults.headers.common['Content-Type'] = 'application/json'
// axios.defaults.timeout = 60 * 1000
Vue.prototype.axios = axios
Vue.prototype.$md5 = md5
Vue.prototype.$userInfos = {}
Vue.prototype.$mqtt = mqtt


var ws = webSocket.webSocketInit(confi.webSocketIp+"/ws/webSocket"); //webSocket建立连接
webSocket.webSocketConnect(ws);
// webSocket.webSocketOnError(ws);
// webSocket.webSocketOnClose(ws);
// webSocket.data.ws = ws;
// Vue.prototype.$webSocket = webSocket
Vue.prototype.$ws = ws
// Vue.prototype.$wsMessage = wsMessage
// window.onbeforeunload = function() {
//   // console.log('--close?--')
//   ws.close();
//   // return 'close'
// } 

// Vue.prototype.$labels = {
//   label1: '',
//   label2: '',
//   label3: '',
//   label4: '',
//   label5: '',
//   label6: '',
//   label7: '',
//   label8: '',
//   label9: '',
//   label10: '',
//   label11: '',
//   label12: '',
//   label13: '',
//   label14: '',
//   label15: '',
//   label16: '',
//   label17: '',
//   label18: '',
//   label19: '',
//   label20: ''
// }
Vue.prototype.$labels = [{
  prop: 'id', //字段名
  type: 'id', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: false //是否可编辑
},{
  prop: 'barcode', //字段名
  type: 'barcode', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: false //是否可编辑
},{
  prop: 'qrcode', //字段名
  type: 'qrcode', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: false //是否可编辑
},{
  prop: 'label1', //字段名(固定条形码文本)
  type: 'text', //字段类型
  showInExport: false, //是否在生成的excel中显示
  editable: false //是否可编辑
},{
  prop: 'label2', //字段名(固定二维码文本)
  type: 'text', //字段类型
  showInExport: false, //是否在生成的excel中显示
  editable: false //是否可编辑
},{
  prop: 'label3', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label4', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label5', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label6', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label7', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label8', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label9', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label10', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label11', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label12', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label13', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label14', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label15', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label16', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label17', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
},{
  prop: 'label18', //字段名
  type: 'text', //字段类型
  showInExport: true, //是否在生成的excel中显示
  editable: true //是否可编辑
}
// ,{
//   prop: 'photo1', //字段名
//   type: 'img', //字段类型
//   showInExport: false, //是否在生成的excel中显示
//   editable: false //是否可编辑
// },{
//   prop: 'photo2', //字段名
//   type: 'img', //字段类型
//   showInExport: false, //是否在生成的excel中显示
//   editable: false //是否可编辑
// },{
//   prop: 'photo3', //字段名
//   type: 'img', //字段类型
//   showInExport: false, //是否在生成的excel中显示
//   editable: false //是否可编辑
// },{
//   prop: 'photo4', //字段名
//   type: 'img', //字段类型
//   showInExport: false, //是否在生成的excel中显示
//   editable: false //是否可编辑
// },{
//   prop: 'photo5', //字段名
//   type: 'img', //字段类型
//   showInExport: false, //是否在生成的excel中显示
//   editable: false //是否可编辑
// }
]
Vue.prototype.$proLabels = {
  zh: {},
  en: {},
  ja: {}
}
for(var i in Vue.prototype.$proLabels) {  //构建商品字段数据
  for(var j = 0; j < Vue.prototype.$labels.length; j++) {
    var prop = Vue.prototype.$labels[j].prop
    Vue.prototype.$proLabels[i][prop] = ''
  }
}
// console.log(Vue.prototype.$proLabels)
// Vue.prototype.$lang = 'zh'
/* eslint-disable no-new */
// var zh = require('./components/common/lang/zh')
// var messages = {
//   zh: Object.assign(zh, zhLocale)
// }
// var en = require('./components/common/lang/en')
// console.log(messages.zh)
// var i18n = new VueI18n({
//   locale: 'zh',
//   messages
// })
var i18n = new VueI18n({
  locale: localStorage.getItem('locale') || confi.language,    // 语言标识
  messages: {
      'zh': Object.assign(require('./components/common/lang/zh'),zhLocale),
      'en': Object.assign(require('./components/common/lang/en'),enLocale),
      'ja': Object.assign(require('./components/common/lang/ja'),jaLocale)
  }
})
// console.log('language_is_',confi.language)
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
// Vue.mixin({
//   data(){
//     return {
//       lang: 'zh'
//     }
//   }
// })

function routeToPermiId(route) {
  var permiId = -1
  var msgKey = ""
  switch(route) {
    case 'shopTemplate': {
      permiId = permiConst.editDemo
      msgKey = "editDemo"
    }; break;
    case 'shopsTemplates': {
      permiId = permiConst.viewDemo
      msgKey = "demo"
    }; break;
    case 'templates': ;
    case 'template': {
      msgKey = "sysDemo"
    }; break;
    case 'system': {
      msgKey = "system"
    }; break;
    case 'errorCode': {
      msgKey = "errcode"
    }; break;
    case 'settings': {
      msgKey = "shopSetting"
    }; break;
  }
  return {
    permiId: permiId,
    msgKey: msgKey
  }
}

router.beforeEach((to, from, next) => {
  // console.log(to,from, i18n)
  //console.log('meta', to.matched, Vue)
  // if(to.path === '/error' || to.path === '/404') {
  //   next()
  // } else if (!authToken.isLoggedIn() && to.path !== '/') {
  //   //console.log(to,from)
  //   if(from.name == 'login' && from.meta.isLogin){
  //     next()
  //   }else{//未登录用户无法访问除登录以外的页面
  //     next('/')
  //     // next()
  //   }
  // } else if(!authToken.isLoggedIn() && to.path === '/') {
  //   next()
  // } else {
  if(to.meta.needClearUser) {
    authToken.removeUserInfo()
    next()
  } else if(to.meta.isErrPage) {
    next()
  } else {
    // console.log(to,from)
    axios({
      method:'get',
      url:'/V1/userInfo',
      headers:{
        'Authorization': 'Bearer ' + authToken.getToken()
      }
    }).then(function(res){
      // console.log(res)
      var userInfosPrev = Vue.prototype.$userInfos
      Vue.prototype.$userInfos = res.data.body
      //console.log(Vue.prototype.$userInfos)
      if(res.data.errcode !== 200){
        //console.log('kong')
        // next(false)
        next({path: '/error'})
        return false
      }
      // var isAdminRole = res.data.body.role === 'root' || res.data.body.role === 'admin'
      // var isRootRole = res.data.body.role === 'root'
      var isAdminRole = false, isAdminRolePrev = Vue.prototype.$userInfos.isAdminRole ? Vue.prototype.$userInfos.isAdminRole : false
      var isRootRole = false, isRootRolePrev = Vue.prototype.$userInfos.isRootRole ? Vue.prototype.$userInfos.isRootRole : false
      var hasStores = false
      var permissions = [], permissionsPrev = Vue.prototype.$userInfos.permissions ? Vue.prototype.$userInfos.permissions : []
      // Vue.prototype.$userInfos.isRootRole = false
      // Vue.prototype.$userInfos.isAdminRole = false
      // Vue.prototype.$userInfos.permissions ? Vue.prototype.$userInfos.permissions = Vue.prototype.$userInfos.permissions.splice(0) : Vue.prototype.$userInfos.permissions = []
      var userRoles = res.data.body.roles
      for (var i = 0; i < userRoles.length; i++) {
        if(userRoles[i].rname === "root") {
          isRootRole = true
          // Vue.prototype.$userInfos.isRootRole = true
          hasStores = true
          permissions = userRoles[i].permissions
          // Vue.prototype.$userInfos.permissions = userRoles[i].permissions
          break
        } else if (userRoles[i].rname === "admin" && userRoles[i].storeId === Number(to.params.storeId)) {
          isAdminRole = true
          // Vue.prototype.$userInfos.isAdminRole = true
          hasStores = true
          permissions = userRoles[i].permissions
          // Vue.prototype.$userInfos.permissions = userRoles[i].permissions
          break
        } else if (userRoles[i].storeId === Number(to.params.storeId)) {
          hasStores = true
          permissions = userRoles[i].permissions
          // Vue.prototype.$userInfos.permissions = userRoles[i].permissions
          break
        }
      }
      Vue.prototype.$userInfos.isRootRole = isRootRole
      Vue.prototype.$userInfos.isAdminRole = isAdminRole
      Vue.prototype.$userInfos.permissions = permissions

      var userPermis = permissions.map(function(item) {
        return item.id
      })
      var toPermiId = routeToPermiId(to.name).permiId
      var msgKey = routeToPermiId(to.name).msgKey

      // if(to.path === '/' && authToken.isLoggedIn()){
      //   to.meta.isLogin = false
      //   authToken.removeUserInfo()
      // }
      if((to.name ==='home'||to.name ==='shop'||to.path ==='/home/shop') && authToken.isLoggedIn()){//路由默认页面处理
        //console.log('1')
        // if(res.data.body.role === 'user'){
        // if(!isRootRole){
        //   next({path:`/home/shop/${res.data.body.storeId}/overview`})
        // } else {
          next({path:'/home/shops'})
        // }
      // } else if(authToken.isLoggedIn() && res.data.body.role === 'user' && to.meta.permission){//普通用户无法访问shops,system,setting页面
      // } else if(authToken.isLoggedIn() && !isRootRole && to.meta.rootPermission){//普通用户和门店管理员无法访问shops,system页面
      } else if(!isRootRole && to.meta.rootPermission){//普通用户和门店管理员无法访问shops,system页面
        //console.log('2')
        // next({path:`/home/shop/${res.data.body.storeId}/overview`})
        msgKey ? Vue.prototype.$message({message: i18n.messages[i18n.locale].viewPermis[msgKey], type: 'error', customClass: "globalMsg"}) : ''
        // next({path:'/home/shops'})
        from.name ? (Vue.prototype.$userInfos = userInfosPrev, Vue.prototype.$userInfos.isRootRole = isRootRolePrev, Vue.prototype.$userInfos.isAdminRole = isAdminRolePrev, Vue.prototype.$userInfos.permissions = permissionsPrev, next(false)) : next({path: '/home/shops'})
      // } else if(authToken.isLoggedIn() && (!isRootRole && !isAdminRole) && to.meta.adminPermission){//普通用户无法访问setting页面
      } else if((!isRootRole && !isAdminRole) && to.meta.adminPermission){//普通用户无法访问setting页面
        //console.log('2')
        // next({path:`/home/shop/${res.data.body.storeId}/overview`})
        msgKey ? Vue.prototype.$message({message: i18n.messages[i18n.locale].viewPermis[msgKey], type: 'error', customClass: "globalMsg"}) : ''
        // next({path:'/home/shops'})
        from.name ? (Vue.prototype.$userInfos = userInfosPrev, Vue.prototype.$userInfos.isRootRole = isRootRolePrev, Vue.prototype.$userInfos.isAdminRole = isAdminRolePrev, Vue.prototype.$userInfos.permissions = permissionsPrev, console.log(Vue.prototype.$userInfos.permissions), next(false)) : next({path: '/home/shops'})
      } else if(to.params.storeId && isNaN(Number(to.params.storeId))) {
        next({path: '/404'})
      // } else if(authToken.isLoggedIn() && to.meta.dataLimit){//普通用户只能访问所属门店的信息
      } else if(to.meta.dataLimit){//普通用户只能访问所属门店的信息
        //console.log('3')
        var name = to.name
        // if(res.data.body.role === 'user' && to.params.storeId !== res.data.body.storeId.toString()){
        // if(!isRootRole && to.params.storeId !== res.data.body.storeId.toString()){
        if(!isRootRole && !hasStores){
          // next({path:`/home/shop/${res.data.body.storeId}/${name ? name : 'overview'}`})
          Vue.prototype.$message({message: i18n.messages[i18n.locale].viewPermis.hasStore, type: 'error', customClass: "globalMsg"})
          next({path:'/home/shops'})
          // next(false)
        // } else if(res.data.body.role !== 'user'){       
        } else {
          axios({
            method:'get',
            url:'/V1/stores/' + to.params.storeId,
            headers:{
              'Authorization': 'Bearer ' + authToken.getToken()
            }
          }).then(function(resp){
            //console.log(resp)
            if(resp.data.errcode !== 200){
              // next(false)
              next({path: '/error'})
              return false
            }
            if(!resp.data.body) {
              next({path: '/404'})
              return false
            }
            if((isRootRole || isAdminRole) && !resp.data.body.active){
              next({path:`/home/shop/${to.params.storeId}/settings`})
            } else if (!(isRootRole || isAdminRole) && !resp.data.body.active) {
              // next('/')
              Vue.prototype.$message({message: i18n.messages[i18n.locale].viewPermis.storeClose, type: 'error', customClass: "globalMsg"})
              next({path:'/home/shops'})
            } else if(!isRootRole && to.meta.viewPermi && userPermis.indexOf(toPermiId) === -1) {
              msgKey ? Vue.prototype.$message({message: i18n.messages[i18n.locale].viewPermis[msgKey], type: 'error', customClass: "globalMsg"}) : ''
              toPermiId === permiConst.editDemo ? next({path: `/home/shop/${to.params.storeId}/shopsTemplates`}) : (!from.name || (to.name === 'shopsTemplates' && from.name === 'shopTemplate') ? next({path: '/home/shops'}) : (Vue.prototype.$userInfos = userInfosPrev, Vue.prototype.$userInfos.isRootRole = isRootRolePrev, Vue.prototype.$userInfos.isAdminRole = isAdminRolePrev, Vue.prototype.$userInfos.permissions = permissionsPrev, next(false)))
              // toPermiId === permiConst.editDemo && userPermis.indexOf(permiConst.viewDemo) !== -1 ? next({path: `/home/shop/${to.params.storeId}/shopsTemplates`}) : next({path:'/home/shops'})
            } else {
              next()
            }
          }).catch(function(err){
            //console.log(err)
            // next(false)
            if(err.response && err.response.status == 401){
              next('/')
              authToken.removeUserInfo()
            } else {
              next({path: '/error'})
            }
          })
        }
        //  else {
        //   next()
        // }
      } else {
        //console.log('4')
        next()
      }
    }).catch(function(err){
      //console.log(err);
      // next(false)
      if(err.response && err.response.status == 401){
        // console.log('err if')
        next('/')
        authToken.removeUserInfo()
      } else {
        // console.log('err else')
        next({path: '/error'})
      }
    })

    //放sessionStorage版本
    // if(to.path==='/' && authToken.isLoggedIn()){
    //   to.meta.isLogin = false
    //   authToken.removeUserInfo()
    // }
    // if((to.name ==='home'||to.name ==='shop'||to.path ==='/home/shop') && authToken.isLoggedIn()){//路由默认页面处理
    //   console.log('1')
    //   if(authToken.getRole() === 'user'){
    //     next({path:`/home/shop/${authToken.getUserInfo().storeId}/overview`})
    //   } else {
    //     next({path:'/home/shops'})
    //   }
    // } else if(authToken.isLoggedIn() && authToken.getRole() === 'user' && to.meta.permission){//普通用户无法访问shops,system,setting页面
    //   console.log('2')
    //   next({path:`/home/shop/${authToken.getUserInfo().storeId}/overview`})
    // } else if(authToken.isLoggedIn() && to.meta.dataLimit){//普通用户只能访问所属门店的信息
    //   console.log('3')
    //   axios({
    //     method:'get',
    //     url:'/V1/stores/' + to.params.storeId,
    //     headers:{
    //       'Authorization': 'Bearer ' + authToken.getToken()
    //     }
    //   }).then(function(res){
    //     console.log(res)
    //     if(res.data.errcode !== 200){
    //       next(false)
    //       return false
    //     }
    //     var name = to.name
    //     if(authToken.getRole() === 'user' && to.params.storeId !== authToken.getUserInfo().storeId.toString()){
    //       next({path:`/home/shop/${authToken.getUserInfo().storeId}/${name ? name : 'overview'}`})
    //     } else if(authToken.getRole() !== 'user' && !res.data.body.active){
    //       next({path:`/home/shop/${to.params.storeId}/settings`})
    //     } else {
    //       next()
    //     }
    //   }).catch(function(err){
    //     console.log(err)
    //     next(false)
    //   })
    // } else {
    //   console.log('4')
    //   next()
    // }
  }
})

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js